module.exports = __webpack_public_path__ + "static/media/IMG-20220519-WA0015.bc47a9fa.jpg";